import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import * as API from "../../Endpoints/Endpoints";

const ViewCategory = () => {
  const [gameCategoryData, setGameCategoryData] = useState(null);
  const { gamecategoryid } = useParams(); // Fetch the category ID from URL
  const navigate = useNavigate();

  useEffect(() => {
    const getGameCategoryData = async () => {
      if (!gamecategoryid) {
        alert('Invalid category ID');
        return;
      }
      try {
        const response = await axios.get(API.GET_CATEGORY_BYID(gamecategoryid));
        setGameCategoryData(response.data); // Assuming the response is a single object
      } catch (error) {
        console.error("Error fetching game category data:", error);
        alert("Failed to load game category details.");
      }
    };
  
    if (gamecategoryid) getGameCategoryData();
  }, [gamecategoryid]);
  
  
  const deleteGameCategory = async (gamecategoryid) => {
    try {
      await axios.delete(API.DELETE_CATEGORY_API(gamecategoryid));
      alert("Game Category deleted successfully");
      navigate("/categorytable"); // Navigate back to game category list
    } catch (error) {
      alert("Failed to delete game category");
      console.error("Error deleting game category:", error.response ? error.response.data : error.message);
    }
  };

  const goBack = () => {
    navigate("/categorytable"); // Navigate back to the category table
  };

  return (
    <div className="py-16 bg-[#f5f5f5] h-full">
      <div className="container px-6 m-auto text-gray-700 md:px-12 xl:px-0">
        <div className="grid gap-6 mx-auto md:w-3/6 lg:w-full lg:grid-cols-1">
          <div className="bg-white rounded-2xl shadow-lg px-8 py-12 sm:px-12 lg:px-8">
            <div className="mb-12 space-y-6">
              {gameCategoryData ? (
                <div>
                  <h5 className="text-2xl font-semibold text-[#e64a32]">
                    Game Category Details
                  </h5>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="flex flex-col">
                      <span className="font-bold">Game Category</span>
                      <span>{gameCategoryData.gamecategory}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Category Name</span>
                      <span>{gameCategoryData.gamecategoryname}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Category Symbol</span>
                      <span>{gameCategoryData.gamecategorysymbol}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-6 space-x-4">
                    <button
                      className="bg-[#e64a32] text-white hover:bg-[#e64a32] font-bold py-2 px-4 rounded"
                      onClick={() => deleteGameCategory(gameCategoryData.gamecategoryid)}
                    >
                      Delete
                    </button>
                    <button
                      className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded"
                      onClick={goBack}
                    >
                      &#8592; Go Back
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-center text-gray-500">Loading game category details...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCategory;
